// The player's answer against the expected one. The spaces and quotes around the answer
// don't count. The expected answer is a value, or a list of accepted values and of
// functions telling whether an answer is accepted.

function cleanAnswer (userAnswer) {
    return userAnswer.replace(/^\s+|\s+$/g, '').replace(/^'+|'+$/g, '').replace(/^"+|"+$/g, '')
}


function isAccepted (accepted, userAnswer) {
    if (typeof accepted === 'function') {
        return accepted(userAnswer)
    }
    return userAnswer === String(accepted)
}


function isCorrect (correctAnswer, userAnswer) {
    if (userAnswer === 'ooo') { //FIXME only in debug mode ?
        return true
    } else if (Array.isArray(correctAnswer)) {
        return correctAnswer.some((accepted) => isAccepted(accepted, userAnswer))
    } else {
        return userAnswer === String(correctAnswer)
    }
}


export default {cleanAnswer, isCorrect}
